import { render, staticRenderFns } from "./course-checkbox-group.vue?vue&type=template&id=f64583e2&scoped=true&"
import script from "./course-checkbox-group.vue?vue&type=script&lang=js&"
export * from "./course-checkbox-group.vue?vue&type=script&lang=js&"
import style0 from "./course-checkbox-group.vue?vue&type=style&index=0&id=f64583e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64583e2",
  null
  
)

export default component.exports